import React, { Component } from 'react';
import { connect } from 'react-redux';
import { crudCreate, crudUpdate, SaveButton, startUndoable } from 'react-admin';

class RoleSaveButtonView extends Component {
  state = {
    uploading: false,
  };

  save = values => {
    const { resource, record, basePath, dispatchCrudUpdate, redirect } = this.props;

    dispatchCrudUpdate(resource, record.id, values, record, basePath, redirect);
  };

  handleClick = () => {
    const { handleSubmit } = this.props;

    return handleSubmit(values => {
      if (typeof values.permission === 'string' || values.permission instanceof String) {
        values.permission = JSON.parse(values.permission);
      }

      this.save(values);
    });
  };

  render() {
    const {
      handleSubmitWithRedirect,
      crudCreate,
      dispatchCrudUpdate,
      startUndoable,
      fetchStart,
      fetchEnd,
      showNotification,
      source,
      resource,
      saving,
      undoable,
      ...props
    } = this.props;

    return (
      <SaveButton
        saving={saving || (this.state.uploading ? { redirect: props.redirect } : false)}
        handleSubmitWithRedirect={this.handleClick}
        {...props}
      />
    );
  }
}

RoleSaveButtonView.defaultProps = {
  undoable: true,
};

export default connect(
  undefined,
  {
    crudCreate,
    dispatchCrudUpdate: crudUpdate,
    startUndoable,
  },
)(RoleSaveButtonView);



// WEBPACK FOOTER //
// ./src/containers/Role/RoleSaveButton.js